module.exports = __webpack_public_path__ + "img/1.a0c0e841.png";